import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { BookingsComp } from './bookings';
import { GetLeadsFromStorage, GetProcessList } from '../../models/process';
import { pnkstore } from '../../stores/pnk-store';
import { useUserStore } from '../../stores/user-store';
import { useNavigate } from 'react-router-dom';
import { GetAllLeads } from '../../models/leads';
import { GetAllBookings } from '../../models/booking';
import { Filters } from '../Filters';

export const Bookings = () => {
    const userData = useUserStore;
    const [openFilter, setOpenFilter] = useState(false);
    const [getBookingList, setGetBookingList] = useState(false);
    const [bookingList, setBookingList] = useState([]);
    const [setNo, setSetNo] = useState(1);
    const [perSet, setPerSet] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [bookingObj, setBookingObj] = useState({});
    const navigate = useNavigate();


    const state = {
        getBookingList: getBookingList,
        bookingList: bookingList,
        totalRecords: totalRecords,
        perSet: perSet,
        setNo: setNo,
        bookingObj: bookingObj
    }

    useEffect(() => {
        setBookingObj({
            'set_no': setNo,
            'per_set': perSet,
        })
        setGetBookingList(true);
    }, []);

    const HandleChangePage = (event, page) => {
        let set_no = setNo;
        if (event.currentTarget.title == 'Go to next page') {
            set_no = set_no + 1;
        }
        else {
            set_no = set_no - 1;
        }
        setSetNo(set_no);
        setBookingObj((prev) => ({ ...prev, ['set_no']: set_no }));
        setGetBookingList(true);
    };

    const HandleChangeRowsPerPage = (event) => {
        let value = event.target.value;
        console.log(event.target.value);
        setPerSet(value);
        setSetNo(1);
        setBookingObj((prev) => ({ ...prev, ['set_no']: 1 }));
        setBookingObj((prev) => ({ ...prev, ['per_set']: value }));
        setGetBookingList(true);

    };

    const ResetPagination = () => {
        setSetNo(1);
        setPerSet(10);
        setBookingObj((prev) => ({ ...prev, ['set_no']: 1 }));
        setBookingObj((prev) => ({ ...prev, ['per_set']: 10 }));
    }

    const NavigateTo = (route) => {
        navigate('/' + route, { state: {} });
    }

    const HandleInputs = (e, name) => {
        let value = e.target.value;

        if (name === 'txtBookingSearchName') {
            setBookingObj((prev) => ({ ...prev, ['txtBookingSearchName']: value }));
        }
    }

    const ToggleFilter = () => {
        //  alert(openFilter);
        // userData.setState({ openFilter: true });
        if (openFilter === true) {
            setOpenFilter(false);
        }
        else {
            setOpenFilter(true);
        }
    }


    const SearchBookingList = (type, searchData) => {
        console.log(searchData);
        if (type === 'reload') {
            setBookingObj({
                'set_no': setNo,
                'per_set': perSet,
                'txtBookingSearchName': ''
            })
        }
        else if (type === 'direct') {
            setBookingObj({
                'set_no': setNo,
                'per_set': perSet,
                'txtBookingSearchName': bookingObj.txtBookingSearchName
            })
        }
        else {
            setBookingObj({
                'set_no': setNo,
                'per_set': perSet,
                'txtBookingSearchStartDate': searchData.txtLeadSearchStartDate,
                'txtBookingSearchEndDate': searchData.txtLeadSearchEndDate,
                'ddlBookingSearchDepartment': searchData.ddlLeadSearchDepartment,
                'ddlBookingSearchOwner': searchData.ddlLeadSearchOwner,
                'ddlBookingSearchProject': searchData.ddlLeadSearchProject,
            })

            ToggleFilter();
        }
        ResetPagination();
        setGetBookingList(true);

    }

    const HandleGetBookingListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res.data.bookinglistresponse.rows[0])
            setBookingList(res.data.bookinglistresponse.rows)
            setTotalRecords(res.data.bookinglistresponse.metarow.totalRecordsInDb);
        }
        else {
            setBookingList([]);
            setTotalRecords(0);
        }
        setGetBookingList(false);
    }



    return (
        <Box>
            {
                openFilter === true ?

                    <Filters page={'Booking'} ToggleFilter={ToggleFilter} SearchList={SearchBookingList} />

                    :
                    null
            }
            <BookingsComp
                mystate={state}
                NavigateTo={NavigateTo}
                HandleInputs={HandleInputs}
                HandleChangePage={HandleChangePage} HandleChangeRowsPerPage={HandleChangeRowsPerPage}
                ToggleFilter={ToggleFilter}
                SearchBookingList={SearchBookingList}
            />
            {((getBookingList === true) ? GetAllBookings(pnkstore, bookingObj, userData.getState().token, HandleGetBookingListSuccessResponse) : "")}
        </Box>
    )
}